module.exports = __webpack_public_path__ + "img/day_hover.e491a932.svg";